import { call, put, delay, select } from 'redux-saga/effects';
import { actions } from '@/reducers/address-reducer';
import searchHorizontalAddresses from '@/services/address/horizontalAddress';
import searchVerticalAddresses from '@/services/address/verticalAddress';
import { reportJSError } from '@/utils/common';
import { getFormatClientsIds } from '@/sagas/utils/clientIdsUtils';
import { normalizeAddressResponse } from './normalizers/addressNormalizer';

const context = (state) => state.main.context;

export function* getHorizontalAddresses({ payload }) {
  const contextApi = yield select(context);
  try {
    const params = {};
    params.ga = getFormatClientsIds(contextApi);
    params.frontVersion = process.env.NEXT_PUBLIC_VERSION_JS;
    const { data } = payload;
    const { address } = data;
    yield delay(300);
    if (address && address.length >= 3) {
      yield put(actions.getHorizontalAddresses(data));
      const response = yield call(searchHorizontalAddresses, {
        context: contextApi,
        params: { ...params, ...data },
      });
      const responseNormalized = normalizeAddressResponse(response, 20);
      yield put(
        actions.setHorizontalAddresses({
          addresses: responseNormalized,
          ...data,
        })
      );
    } else {
      yield put(
        actions.setHorizontalAddresses({
          addresses: null,
          ...data,
        })
      );
    }
  } catch (error) {
    reportJSError(
      error,
      'getHorizontalAddresses',
      'sagas/address-sagas',
      contextApi
    );
    const { data } = payload;
    yield put(actions.getHorizontalAddressesError(data));
  }
}
export function* getVerticalAddresses({ payload }) {
  const contextApi = yield select(context);
  try {
    const params = {};
    params.ga = getFormatClientsIds(contextApi);
    params.frontVersion = process.env.NEXT_PUBLIC_VERSION_JS;
    const { data } = payload;
    const { address, idGeographicSite } = data;
    yield delay(300);
    if (address === '' || (address && address.length >= 0)) {
      yield put(actions.getVerticalAddresses(data));
      const response = yield call(searchVerticalAddresses, {
        context: contextApi,
        params: { ...params, address, idGeographicSite },
      });
      const responseNormalized = normalizeAddressResponse(response, 60);
      yield put(
        actions.setVerticalAddresses({
          addresses: responseNormalized,
          ...data,
        })
      );
    } else {
      yield put(actions.setVerticalAddresses(null));
    }
  } catch (error) {
    reportJSError(
      error,
      'getVerticalAddresses',
      'sagas/address-sagas',
      contextApi
    );
    const { data } = payload;
    yield put(actions.getVerticalAddressesError(data));
  }
}
